import { Injectable } from '@angular/core';
import { forkJoin, map, Observable, switchMap } from 'rxjs';
import { Language, LanguageService } from '../api';

export interface TranslationCache {
  languages: Language[];
  translationsByLanguageCode: Record<string, Record<string, string>>;
}

@Injectable({ providedIn: 'root' })
export class TranslationHelperService {
  constructor(private languageService: LanguageService) {}

  load(): Observable<TranslationCache> {
    return this.languageService.getLanguages().pipe(
      map(languages => languages.filter((language): language is Language & { Code: string } => !!language.Code)),
      switchMap(languages => forkJoin(
        languages.map(language => this.languageService.getTranslations(language.Code, false))
      ).pipe(
        map(translationResults => ({
          languages,
          translationsByLanguageCode: languages.reduce<Record<string, Record<string, string>>>((result, language, index) => {
            result[language.Code] = translationResults[index];
            return result;
          }, {})
        }))
      ))
    );
  }
}